import { render, staticRenderFns } from "./DrawArea.vue?vue&type=template&id=5c92b2c1&scoped=true&"
import script from "./DrawArea.vue?vue&type=script&lang=ts&"
export * from "./DrawArea.vue?vue&type=script&lang=ts&"
import style0 from "./DrawArea.vue?vue&type=style&index=0&id=5c92b2c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c92b2c1",
  null
  
)

export default component.exports